import React, { useEffect } from 'react';
import { Form } from 'antd';

import { setStaticFormValuesFromFilter } from '../../common/filterHelpers';
import { SearchFormProps } from '../../common/searchFormField.types';
import { useGetCitiesDictionary } from '../../common/useGetCitiesDictionary';
import { useGetRecommendersDictionary } from '../../common/useGetRecommendersDictionary';
import { FormDatePicker } from '../../components/forms/FormDatePicker';
import { FormDoubleInput } from '../../components/forms/FormDoubleInput';
import { FormInput } from '../../components/forms/FormInput';
import { FormSelect } from '../../components/forms/FormSelect';
import { FormSelectMultiple } from '../../components/forms/FormSelectMultiple';
import { StyledColumn } from '../../components/StyledColumn';

export const CandidatesSearchForm: React.FC<SearchFormProps> = ({ form, filter }) => {
  const { data, isLoading } = useGetCitiesDictionary();
  const citiesOptions = data && !isLoading ? data?.map((city) => ({ value: city.value, content: city.value })) : [];

  const { data: recommenders, isLoading: recommendersLoading } = useGetRecommendersDictionary();
  const recommenderOptions =
    recommenders && !recommendersLoading
      ? recommenders.map((recommender) => ({ value: recommender.value, content: recommender.value }))
      : [];

  useEffect(() => setStaticFormValuesFromFilter(form, filter), [filter, form]);

  return (
    <Form form={form} style={{ flexGrow: '1' }} layout="vertical" colon={false}>
      <StyledColumn gap="0.5rem">
        <FormDoubleInput
          leftInput={<FormInput name="firstName" label="Candidate first name" />}
          rightInput={<FormInput name="lastName" label="Candidate last name" />}
        />

        <FormSelectMultiple name="city" label="Cities" options={citiesOptions} />

        <FormDoubleInput
          leftInput={<FormDatePicker name={['createdDate', 'start']} label="Created from" />}
          rightInput={<FormDatePicker name={['createdDate', 'end']} label="Created to" />}
          withDivider
        />

        <FormInput name="appliedPosition" label="Applied position" />
        <FormInput name="cv" label="CV" />
        <FormSelect name="recommendedBy" label="Recommended by" options={recommenderOptions} />
      </StyledColumn>
    </Form>
  );
};
